import { Directive, HostListener, input, output } from '@angular/core';

@Directive({
  selector: '[appClickDouble]',
})
export class ClickDoubleDirective {
  doubleClickDelay = input(250);

  onSingleClick = output();
  onDoubleClick = output();

  #clickTimeoutId: number | null = null;

  @HostListener('click', ['$event'])
  onClick(_: MouseEvent): void {
    if (this.#clickTimeoutId !== null) {
      window.clearTimeout(this.#clickTimeoutId);
    }

    this.#clickTimeoutId = window.setTimeout(() => {
      this.onSingleClick.emit();
      this.#clickTimeoutId = null;
    }, this.doubleClickDelay());
  }

  @HostListener('dblclick', ['$event'])
  onDblClick(_: MouseEvent): void {
    if (this.#clickTimeoutId !== null) {
      window.clearTimeout(this.#clickTimeoutId);
      this.#clickTimeoutId = null;
    }

    this.onDoubleClick.emit();
  }
}
